export async function connectOneSignal(
  user: Record<string, unknown>
): Promise<void> {
  // repassa pro React Native
  window?.ReactNativeWebView?.postMessage(
    JSON.stringify({
      type: 'ONESIGNAL_USER_LOGIN',
      payload: user,
    })
  );
}

export async function disconnectOneSignal(): Promise<void> {
  // repassa pro React Native
  window?.ReactNativeWebView?.postMessage(
    JSON.stringify({
      type: 'ONESIGNAL_USER_LOGOUT',
    })
  );
}
